<div class="task-breakdown">
  @if (hasNoData()) {
    <p class="task-breakdown__note">No task detail available</p>
  } @else if (isEmpty()) {
    <p class="task-breakdown__note">No task time recorded</p>
  } @else {
    <ul class="task-breakdown__list">
      @for (row of rows(); track $index) {
        <li
          class="task-breakdown__row"
          [class.has-no-code]="row.hasNoCode"
          [class.has-placeholder-description]="row.hasPlaceholderDescription"
        >
          <span class="task-breakdown__code">{{ row.label }}</span>
          <span
            class="task-breakdown__description"
            #descText
            [matTooltip]="row.description"
            [matTooltipDisabled]="true"
            #tooltip="matTooltip"
            (mouseenter)="updateTooltipDisabled(descText, tooltip)"
            matTooltipClass="app-tooltip"
            matTooltipPosition="above"
            >{{ row.description }}</span
          >
          <span class="task-breakdown__hours">{{ row.hours }}</span>
        </li>
      }
    </ul>
  }
</div>
